export const SWEDISH_TRANSLATIONS = {
    'a11y': {
        'show' : 'Visa',
        'hide': 'Dölj'
    },
    'router': {
        'back-to-start': 'Go back to start'
    },
    'button': {
        'toggle-map': 'Kartvy',
        'return-back': 'Tillbaka till frågan',
        'save-draft': 'Spara som utkast',
        'send-answers': 'Se resultat',
        'next': 'Nästa',
        'copy-draft-link': 'Kopiera',
        'copy-draft-link-copied': 'Kopierat!',
        'show-results': 'Visa resultat',
        'cancel': "Ångra",
        'send': "Skicka",
        'print': 'Skriva ut'
    },
    'draft-form': {
        'input': {
            'draft-password': "Lösenord för utkastet",
            'draft-email': 'E-post (frivillig)',
        },
        'info': {
            'draft-password': 'Ange ett lösenord som är minst sex tecken långt och innehåller en stor bokstav och ett nummer',
            'draft-email': 'Ange en e-postadress där du får en länk för att kunna fortsätta att svara på enkäten',
            'draft-email-extra': 'E-postadressen sparas inte i systemet',
            'give-password': 'Ange lösenord'
        },
        'validation': {
            'password-missing': 'Lösenord saknas',
            'password-invalid': 'Ange ett lösenord som är minst sex tecken långt och innehåller en stor bokstav och ett nummer',
            'email-invalid': "Ange e-post i formatet fornamn.efternamn['@']email.fi",
            'password-failed': "Försök att ange lösenordet på nytt"
        }
    },
    'end-of-path': {
        'continue': 'Du är klar med det här steget i enkäten. Med knapparna nedan kan du fortsätta till de delar av enkäten som du inte har besvarat.',
        'save-or-send': 'Alternativt kan du även fortsätta att fylla i enkäten senare genom att trycka på Spara som utkast eller avsluta enkäten genom att trycka på knappen Se resultat.',
        'completed': 'Du har fyllt i hela enkäten.'
    },
    'table': {
        'question': 'Rubrik på delen eller fråga',
        'answers': 'Svar',
        'points': 'Poäng',
        'clicked': '',
        'completion': 'Undersökningens slutförandestatus',
        'max-weight': "Maximalt antal poäng",
        'total': 'Totalt',
        'plain-question': 'Fråga'
    },
    'survey-stages-left': 'Jatka kyselyyn vastaamista valitsemalla uusi kysymys alla olevista painikkeista.',
    'survey-progress-percent': 'Av enkäten har fyllts procent',
    'survey-progress-current-stage': 'Svar ges',
    'survey-progress-total-stages': 'Totalt antal steg',
    'svg-map-title': 'Kartvy över stegen i enkäten',
    'points': 'poäng',
    'total-points': 'Totalpoäng',
    'survey-max-points': 'maxpoäng',
    'topic': 'Del',
    'move-to-stage': 'Gå till nästa steg i enkäten',
    'answer-given': 'Svar angett',
    '404-message': '404 - Not found',
    'thank-you-message': 'Tack för dina svar!',
    'saved-as-a-draft-message': 'Enkäten är nu sparad som utkast. Du kan öppna utkastet med det angivna lösenordet på: ',
    'form-steps': 'Formulärets steg',
    'confirm-submit-info': 'Vill du se resultat? Dina svar och poäng samlas i en tabell och du kan inte längre ändra dina svar efter detta.',
    'improving-topics': 'Seuraavissa aihealueissa on kehitettävää',
    'total-points-per-topic': 'Kokonaispistemääräsi: ',
    'survey-result-view-text-1': 'Vastaustesi pistemäärät aihealueittain:',
    'survey-result-view-text-2': 'Terveet tilat -toimintamallista löytyy tietoa, ohjeita ja hyviä käytäntöjä kyselyn kaikkiin aihealueisiin. Löytyisikö toimintamallista apua sinun kunnallesi? Kannattaa tutustua!',
    'survey-result-view-text-3': 'Terveet tilat -toimintamalli (',
    'modal': {
        'close': 'Sulje'
    },
    'actions': {
        'check-answers': "Voit katsoa tästä vastauksiasi"
    },
    'review-text-pos': "Onneksi olkoon! Vastaustesi perusteella vaikuttaa siltä, että kuntanne sisäilma-asiat ovat hyvällä mallilla ja kunnassanne on selvästi tehty töitä hyvän sisäilman eteen. Alta löydät vielä listauksen niistä osa-alueista, joissa voi olla vielä hieman parannettavaa.",
    'review-text-med': "Vastaustesi perusteella vaikuttaa siltä, että kuntanne on huomioinut sisäilma-asioita, mutta vielä on jonkin verran parannettavaa. Alta löydät listauksen niistä kaikista osa-alueista, joihin kannattaa tulevina vuosina kiinnittää huomiota.",
    'review-text-neg': "Vastaustesi perusteella vaikuttaa siltä, että kunnassanne ei ole vielä riittävästi huomioitu sisäilma-asioita kunnan toiminnassa. Alta löytyvän listauksen avulla voitte yhdessä lähteä kehittämään kuntanne toimintaa sisäilma-asioiden edistämiseksi."
}